import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// utils
import { isColorLight } from 'utils/tree'
import { darken, ellipsis } from 'polished'

export const Wrapper = styled('div')<{ isDisabled?: boolean }>`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 8px;
  flex-wrap: wrap;

  ${ButtonsWrapper} {
    top: 0;
    display: none;
  }

  &:hover {
    ${ButtonsWrapper} {
      display: flex;
    }
  }
`

export const Button = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  cursor: pointer;

  &:hover {
    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }
`

export const Option = styled.div<{ color: string }>`
  color: ${({ color }) => (isColorLight(color) ? colors.black : colors.white)};
  background-color: ${({ color = colors.gray250 }) => color};
  height: fit-content;
  padding: 2px 16px;
  border-radius: 12px;

  ${ellipsis('100%')};
`

export const Label = styled.span`
  font-weight: bold;
  font-size: 12px;
`

export const SetContainer = styled.div`
  display: flex;
  gap: 8px;
`
